import { useEffect } from 'react';

const TawkToChat = () => {
  useEffect(() => {
    if (!document.getElementById('tawk-script')) {
      window.Tawk_API = window.Tawk_API || {};
      window.Tawk_LoadStart = new Date();

      const script = document.createElement('script');
      script.id = 'tawk-script';
      script.async = true;
      script.src = 'https://embed.tawk.to/67af804e5157dd190fcb95d6/1ik2oqd0n';
      script.charset = 'UTF-8';
      script.setAttribute('crossorigin', '*');
      document.body.appendChild(script);
    }

    return () => {
      const existingScript = document.getElementById('tawk-script');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  return null;
};

export default TawkToChat;
